import {
  Component,
  ViewChild,
  OnInit,
  AfterViewInit,
  ElementRef,
  HostListener,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import swal from 'sweetalert2';
import { NgZone } from '@angular/core';
import { ApidataService } from '../apidata.service';
import { HeaderComponent } from '../header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { EventEmitter } from 'stream';
import { MetaTagService } from '../meta-tag.service';
import { ChangeDetectorRef } from '@angular/core';
import { environment, GINConstants } from '../../environments/environments';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';
declare var Dropbox: any;
declare var $: any;
declare var window: any;
declare var gapi: any;
declare var google: any;
@Component({
  selector: 'app-artical',
  standalone: true,
  imports: [
    HeaderComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FooterComponent,
    FeedbackComponent,
    IconsFreeToolsComponent,
    PremiumComponent,
    PremiumModalStartupComponent,
],
  providers: [ApidataService],
  templateUrl: './artical.component.html',
  styleUrl: './artical.component.css',
})
export class ArticalComponent {


  recaptcha_message = ""
  got_recpatcha: boolean = false;
  captchaToken: string | null = null;
  showonlydrive: boolean = false;
  public mobilescreen: boolean = false;
  public responseformodbile: boolean = false;
  popupVisible = false;
  error: boolean = false;
  success: boolean = false;
  public showfeedbackloader: boolean = false;
  public eFsubIF: boolean = false;
  ifsub: boolean = false;
  public gotresponse: boolean = false;
  public showbuttons: boolean = false;
  public loaderAlert: boolean = false;
  public menuafterresponse: boolean = false;
  public copiedtext: boolean = false;


  public cleartxtbtn: boolean = false;
  subscribed_user: boolean = false;
  isUserLoggedin: boolean = false;


  activeTab: string = '';
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  public editortext = '';
  public copried_txt: string = '';
  selectedTab: string = 'tab1';
  editorTxtAI: string;
  inputText: string = '';


  spellingmistake = 0;
  garmmarmistake = 0;
  count = 5;
  selectedValue: number;
  public char_count = 0;
  word_count = 0;


  errorAlerts;
  successAlert;
  dangerAlerts;


  popupPosition: any;
  public form_message: any;
  public form_email: any;
  public EdittorHeight: any;
  public EdittorWidth: any;
  activeElement: HTMLElement | null = null;
  firstSynonym: any;
  eFsubText2: any;
  editorTxt: any;


  stars: number[] = [1, 2, 3, 4, 5];
  popupSynonyms: string[] = [];
  public spanwords = [];



  constructor(
    private webservices: ApidataService,
    private el: ElementRef,
    private router: Router,
    private https: HttpClient, private metaService: MetaTagService,
    private cdr: ChangeDetectorRef
  ) { }





  ngOnInit(): void {
    // const isMobile = window.innerWidth <= 600;

    // if (isMobile) {
    //   this.router.navigate(['/app-article-rewriter']);
    // } else {
    //   this.router.navigate(['/article-rewriter']);
    // }
    if (this.captchaVisible) {
      this.loadAndRenderTurnstile();
    }
    this.metaService.updateTags("Article Rewriter Tool | Accurate Article & Essay Rewriter",
      "Grammarin's article rewriter tool uses advanced AI that helps to rewrite articles & paragraphs. Use this article spinner to create unique content with ease."
      , "https://www.grammarin.com/article-rewriter",
      "https://www.grammarin.com/assets/images/OG-Images/Article Rewriter.png",
      'Article Rewriter');
    $('.tab_content').hide();
    $('.tab_content:first').show();

    $('ul.tabs li').click(function () {
      $('.tab_content').hide();
      var activeTab = $(this).attr('rel');
      $('#' + activeTab).fadeIn();

      $('ul.tabs li').removeClass('active');
      $(this).addClass('active');

      $('.tab_drawer_heading').removeClass('d_active');
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass('d_active');

    });
    $('.tab_container').css('min-height', function () {
      return $('.tabs').outerHeight() + 50;
    });

    $('.tab_drawer_heading').click(function () {
      $('.tab_content').hide();
      var d_activeTab = $(this).attr('rel');
      $('#' + d_activeTab).fadeIn();

      $('.tab_drawer_heading').removeClass('d_active');
      $(this).addClass('d_active');

      $('ul.tabs li').removeClass('active');
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass('active');
    });

    this.activeTab = 'q5';
  }
  recaptchaWidgetId: number | undefined;



  captchaVisible: boolean = false;
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';

  handleButtonClick(): void {
    if (this.loaderAlert) {
      return;
    }
    $("#editor").find("span").contents().unwrap();
    this.char_count = $("#editor").text().length;
    this.word_count = $("#editor").text().trim().split(/\s+/).length;

    // if (this.word_count >= 10 && this.word_count <= 300 && this.editorTxt != 'Upload Your ContentType or Paste AI Text hereSample TextPaste text') {
    //   this.showCaptchaModal();
    // } else {
    //   this.showAlert("Enter 10 to 300 words to check the Article.", "");
    // }

    if (!this.subscribed_user)
      if (this.word_count >= 15 && this.word_count <= 1000) {
        this.showCaptchaModal();
      } else {
        this.showAlert("Enter 15 to 1000  words to check the Article.", "");
      }
    else if (this.subscribed_user)
      if (this.word_count >= 15 && this.word_count <= 10000) {
        this.showCaptchaModal();
      } else {
        this.showAlert("Enter 15 to 10,000  words to check the Article.", "");
      }
  }

  showCaptchaModal(): void {
    if (!this.captchaVisible) {
      this.captchaVisible = true;
      this.cdr.detectChanges();
      this.loadAndRenderTurnstile();
    } else {
      this.recaptchaMessage = 'Please complete the CAPTCHA.';
      this.color = '#721c24';
    }
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () =>
        //  console.error('Failed to load Turnstile script.');
        document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
  }

  onTurnstileSuccess(token: string): void {
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    this.articleWriter();
  }

  onTurnstileError(): void {
    // console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
    } else {
    }
  }

  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  textfromAI() {
    if (localStorage.getItem('editorValueAI')) {
      this.showParagraph = false;
    }
    setTimeout(() => {
      if (localStorage.getItem('editorValueAI')) {
        this.editorTxtAI = localStorage.getItem('editorValueAI');
        this.char_count = this.editorTxtAI.length;
        this.word_count = this.editorTxtAI.trim().split(/\s+/).length;
        localStorage.removeItem('editorValueAI');

        if (this.editorTxtAI != null && this.editorTxtAI.length !== 0) {
          this.textDivRef.nativeElement.innerHTML = this.editorTxtAI;
        }
      }
    }, 1000); // 2000 milliseconds = 2 seconds
  }

  pcroute() {
    var editortxt = '';
    editortxt = $('#editor2').text();
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/plagiarism-checker'])
    );
    window.open(url, '_blank');
  }
  gcroute() {
    var editortxt = '';
    editortxt = $('#editor2').text();
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    window.open(url, '_blank');
  }
  sampletext() {
    $('#editor').html(
      "We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. Suppose you have detected that some proportion of your text is plagiarized. In that case, you can opt to use the best article rewriter to make your plagiarized sentences and display their plagiarism-free version in a matter of seconds. It means that it's not only wasted an hour or more trying to rewrite plagiarism from the text yourself and then putting to some responsibility for both of these demanding jobs and providing you 100% unique content in the blink of an eye. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible. You can enjoy the following features."
    );
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().trim().split(' ').length;
    this.showParagraph = false;
  }

  pasteText(): void {
    navigator.clipboard
      .readText()
      .then((pastedText) => {
        document.execCommand('insertText', false, pastedText);
        $('#editor').html(pastedText);
        this.char_count = $('#editor').text().length;
        this.word_count = $('#editor').text().trim().split(' ').length;
        this.showParagraph = false;
      })
      .catch((err) => {
        // console.error('Failed to read clipboard contents: ', err);
      });
  }

  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  countStar(star) {
    this.selectedValue = star;
  }

  showParagraph: boolean = true;
  @ViewChild("text") text: ElementRef;

  isPopupOpen = false;

  public clientId =
    '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
  public scope = [
    'profile',
    'email',
    'https://www.googleapis.com/auth/drive.file',
  ].join(' ');

  public oauthToken?: any;
  public pickerApiLoaded = false;
  @ViewChild('fileInput') fileInput;
  @ViewChild('editor') editor!: ElementRef<HTMLDivElement>;


  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    const targetElement = event.target as HTMLElement;

    if (
      (targetElement.id === 'editor' || targetElement.closest('#editor')) &&
      clipboardData &&
      clipboardData.getData
    ) {
      const pastedContent = clipboardData.getData('text/plain');
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (!range.collapsed) {
          range.deleteContents();
          range.insertNode(document.createTextNode(pastedContent));
        } else {
          range.insertNode(document.createTextNode(pastedContent));
        }
        const newRange = document.createRange();
        newRange.selectNodeContents(range.endContainer);
        newRange.collapse(false);
        selection.removeAllRanges();
        selection.addRange(newRange);
      }

      this.showParagraph = false;
      this.char_count = $('#editor').text().length;
      this.word_count = $('#editor').text().trim().split(/\s+/).length;
    }
  }

  getElementHeightById(id: string): void {
    const element = this.el.nativeElement.querySelector(`#${id}`);
    if (element) {
      this.EdittorHeight = element.clientHeight;
      this.EdittorWidth = element.clientWidth;
    } else {
    }
  }
  public eFormSubmission(event: any) {
    event.preventDefault();
    this.eFsubIF = false;
    $('#eFsubText2').hide();
    this.form_email = $('#form_email').val();
    this.form_message = $('#form_message').val();
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (this.form_message.length === 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      $('#form_message').val('').css('border-color', 'red');
      this.eFsubIF = true;
      $('#eFsubText2').show();
      setTimeout(function () {
        $('#eFsubText2').hide();
        $('#form_message').css('border-color', '#08ba9c');
        this.eFsubIF = false;
      }, 3000);
    } else {
      this.showfeedbackloader = true;
      const headers = new HttpHeaders({
        Authorization: environment.AuthorizationGIN,
      });
      this.https
        .post(
          environment.API_URL + '/api/feedbackForm',
          {
            email: this.form_email,
            comment: this.form_message,
            page_name: 'home',
            emotion: this.selectedValue,
          },
          { headers }
        )
        .subscribe(
          (response) => {
            this.showfeedbackloader = false;
            this.color = 'green';
            this.eFsubText2 = 'Form Submitted Successfully!';
            this.eFsubIF = true;
            $('#eFsubText2').show();
            setTimeout(function () {
              $('#eFsubText2').hide();
              this.eFsubIF = false;
            }, 3000);
            $('#form_email').val('').css('border-color', '#08ba9c');
            $('#form_message').val('').css('border-color', '#08ba9c');
          },
          (error) => {
            // console.error(error);
          }
        );
    }
  }
  checkMail() {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    this.form_email = $('#form_email').val();
    if (reg.test(this.form_email) === false) {
      this.color = '#721c24';
      this.dangerAlerts = 'Please provide correct Email';
      $('#form_email').val('').css('border-color', 'red');
      this.ifsub = true;
      $('#dangerAlerts').show();
      setTimeout(function () {
        $('#dangerAlerts').hide();
        $('#form_email').css('border-color', '#08ba9c');
        this.ifsub = false;
      }, 3000);
    }
  }
  clearfeedbackform() {
    this.selectedValue = 0;
    $('#form_email').val('').css('border-color', '#e7e7ec');
    $('#form_message').val('').css('border-color', '#e7e7ec');
  }
  public ngAfterViewInit(): void {
    this.editor.nativeElement.addEventListener('keyup', () => this.count_Words_Character2());
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
    this.textfromAI();
    this.getElementHeightById('editor');
    this.getBrowserWidth();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('#scroll-to-top').fadeIn('slow');
      } else {
        $('#scroll-to-top').fadeOut('slow');
      }
    });
    $('#scroll-to-top').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 700);
      return false;
    });

    const storedStatus = JSON.parse(localStorage.getItem('premium_user_done') || 'false');
    // console.log(storedStatus,"storedStatus")
    this.subscribed_user = storedStatus;
    this.profile_id = localStorage.getItem("profile_id");
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    }
    else {
      this.isUserLoggedin = true;
    }
    if (this.profile_id && this.profile_id != 1) {
      this.webservices
        .getUserProfileContents(this.profile_id)
        .subscribe((data) => {
          //  console.log(data,"data")
          this.LoadProfileData(data)

        });


    }
  }
  public LoadProfileData(data: Response) {
    let receivedData = data;
    this.subscribed_user= receivedData['contents'][0][5];
    // console.log(this.subscribed_user,"this.subscribed_user")
  }

  public getBrowserWidth = function () {
    if (window.innerWidth <= 430) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return 'xs';
    } else if (window.innerWidth < 991) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return 'sm';
    } else if (window.innerWidth < 1199) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return 'md';
    } else {
      this.mobilescreen = false;
      this.responseformodbile = false;
      return 'lg';
    }
  };

  public getContent(event, text) {
    this.copiedtext = false;
    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;
    this.editortext = text;
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
    if (ctrlDown && event.keyCode == vKey) {
      this.showParagraph = false;
      var editortxt = $('#editor').text();
    }
    var editortxt = $('#editor').text();
  }


  onTextClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (this.activeElement) {
      this.activeElement.classList.remove('active');
      this.activeElement.style.color = 'rgb(1, 170, 142)';
      this.activeElement.style.backgroundColor = '#f7f7fa';
    }

    if (target.classList.contains('words')) {
      target.style.color = 'black';
      target.style.backgroundColor = '#08BA9C';
      target.classList.add('active');
      this.activeElement = target;
      const synonyms = target.getAttribute('data-synonyms')?.split(';') || [];
      this.firstSynonym = synonyms.length > 0 ? synonyms[0] : null;

      const rect = target.getBoundingClientRect();
      var topMargin = rect.top + window.scrollY - 220;

      var leftMargin = rect.left + window.scrollX - 475;
      if (window.innerWidth < 430 && leftMargin > 100) {
        leftMargin = 100;
      }
      if (window.innerWidth < 691 && leftMargin > 210) {
        leftMargin = 210;
      }
      const position = { top: `${topMargin}px`, left: `${leftMargin}px` };

      this.popupSynonyms = synonyms;
      this.popupPosition = position;
      this.popupVisible = true;
    } else {
      this.popupVisible = false;
    }
  }

  selectSynonym(synonym: string) {
    if (this.activeElement) {
      this.activeElement.innerText = synonym;
      this.activeElement.classList.remove('active');
      this.activeElement.style.color = 'rgb(1, 170, 142)';
      this.activeElement.style.backgroundColor = '#f7f7fa';
    }
    this.popupVisible = false;
  }

  useInputText() {
    if (this.activeElement) {
      if (this.inputText.trim() === '') {

      } else {
        this.activeElement.innerText = this.inputText;
        this.activeElement.classList.remove('active');
        this.activeElement.style.color = 'rgb(1, 170, 142)';
        this.activeElement.style.backgroundColor = '#f7f7fa';
        this.inputText = '';
      }
      this.popupVisible = false;
    }
  }
  closepopUpArt() {
    this.activeElement.classList.remove('active');
    this.activeElement.style.color = 'rgb(1, 170, 142)';
    this.activeElement.style.backgroundColor = '#f7f7fa';
    this.popupVisible = false;
  }

  articleWriter() {
    const editorContent = $('#editor').text().trim();
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().trim().split(/\s+/).length;
    if (!this.isCaptchaVerified) {
      return;
    }

    const isPlaceholder =
      editorContent === "Upload Your ContentType or Paste AI Text here"


    if (isPlaceholder) {
      this.showAlert(' Enter 10 to 300 words to check the Article.', '');
      return;
    }

    this.gotresponse = false;
    this.editorTxt = $('#editor').text().trim();
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().trim().split(/\s+/).length;
    this.spanwords = [];
    this.menuafterresponse = false;
    this.showbuttons = false;

    if (
      this.word_count >= 15 && this.editorTxt != 'Upload Your ContentType or Paste AI Text hereSample TextPaste text'
    ) {
      this.loaderAlert = true;
      this.cleartxtbtn = true;
      $('#editor').html(this.editorTxt);
      if (window.innerWidth > 868 && this.profile_id !== '1'){
        let data2 = JSON.stringify({
          homeText: editorContent,
          profile_id: this.profile_id || '1',
        });

        let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

        this.webservices.postResources(data2, url).subscribe((data) => {
          let receivedData = data;

          localStorage.setItem('editorValueAI', editorContent);
          this.doc_id = receivedData['new_doc_id'];

          this.router.navigate(['/article'], {
            queryParams: { doc: this.doc_id },
          });

          const url = this.router.serializeUrl(this.router.createUrlTree(['']));

        });
        return;
      }
      this.webservices.articleapi(this.editorTxt).subscribe((data) => {
        $('#editor').html(this.editorTxt);
        this.char_count = $('#editor').text().length;
        this.word_count = $('#editor').text().trim().split(/\s+/).length;
        this.showParagraph = false;
        var updatedContent = data['updated_content'];
        if (updatedContent) {
          this.gotresponse = true;
          $('#editor2').html(updatedContent);
          document
            .getElementById('editor2')
            .setAttribute('contenteditable', 'false');
          this.showbuttons = true;
          this.loaderAlert = false;
          this.menuafterresponse = true;
          this.cleartxtbtn = false;
        }
        var editorSpan = document.getElementById('editor2');
        const spans = Array.from(editorSpan.querySelectorAll('span'));
        spans.forEach((span) => {
          span.style.color = '#01AA8E';
          span.style.cursor = 'pointer';
        });
      });
    } else {
      if (!this.subscribed_user) {
        this.showAlert("Enter 15 to 1000  words to check the Article.", "");
      }
      else if (this.subscribed_user) {
        this.showAlert("Enter 15 to 10,000  words to check the Article.", "");
      }
      // this.showAlert(' Enter 10 to 300 words to check the Article.', '');
    }
    // }
  }
  profile_id;
  public doc_id = '';
  // articleWriter() {
  //   const editorContent = $('#editor').text().trim();
  //   this.char_count = $('#editor').text().length;
  //   this.word_count = $('#editor').text().trim().split(/\s+/).length;
  //   if (!this.isCaptchaVerified) {
  //     return;
  //   }

  //   const isPlaceholder =
  //     editorContent === "Upload Your ContentType or Paste AI Text here"


  //   if (isPlaceholder) {
  //     this.showAlert(' Enter 10 to 300 words to check the Article.', '');
  //     return;
  //   }

  //   this.gotresponse = false;
  //   this.editorTxt = $('#editor').text().trim();
  //   this.char_count = $('#editor').text().length;
  //   this.word_count = $('#editor').text().trim().split(/\s+/).length;
  //   this.spanwords = [];
  //   this.menuafterresponse = false;
  //   this.showbuttons = false;

  //   if (
  //     this.word_count >= 10 && this.word_count <= 300 && this.editorTxt != 'Upload Your ContentType or Paste AI Text hereSample TextPaste text'
  //   ) {
  //     this.loaderAlert = true;
  //     this.cleartxtbtn = true;
  //     $('#editor').html(this.editorTxt);
  //     this.loaderAlert = true;

  //     if (window.innerWidth < 868){
  //     let data2 = JSON.stringify({
  //       homeText: editorContent,
  //       profile_id: this.profile_id || '1',
  //     });

  //     let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

  //     this.webservices.postResources(data2, url).subscribe((data) => {
  //       let receivedData = data;

  //       localStorage.setItem('editorValueAI', editorContent);
  //       this.doc_id = receivedData['new_doc_id'];

  //       this.router.navigate(['/article'], {
  //         queryParams: { doc: this.doc_id },
  //       });

  //       const url = this.router.serializeUrl(this.router.createUrlTree(['']));

  //     });
  //   }
  //   } else {
  //     this.showAlert(' Enter 10 to 300 words to check the Article.', '');
  //   }

  // }

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;
  }

  onclickeditor(event: MouseEvent) {
    event.stopPropagation();
    if (this.char_count === 0 && !this.showParagraph) {
      this.word_count = 0;
      this.char_count = 0;
    }
    this.showParagraph = false;
    const sampleText = 'Enter your Text HereORUpload file from above options';
    const editorContent = $('#editor').text().trim();
    if (editorContent === sampleText) {
      this.word_count = 0;
      this.char_count = 0;
    }
    if (editorContent === '') {
      this.word_count = 0;
      this.char_count = 0;
    } else {
      this.word_count = editorContent
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
    }
  }
  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement) {
    if (!this.editor) {
      return;
    }

    const clickedElementId = targetElement.id;
    const excludedButtonIds = [
      'checkgrammar-btn-art',
      'downloadfile',
      'copy-btn',
      'retry-btn',
      'footerlinksforroute',
    ];
    const editorContent = this.editor.nativeElement.innerText.trim();
    if (editorContent !== '') {
      return;
    }

    if (excludedButtonIds.includes(clickedElementId)) {
      return;
    }

    if (!this.editor.nativeElement.contains(targetElement)) {
      if (!this.word_count || !this.char_count) {
        this.showParagraph = true;
      } else {
        this.showParagraph = false;
      }

      this.word_count = 0;
      this.char_count = 0;

      const editorText = this.editor.nativeElement.innerText.trim();
      this.word_count = editorText
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
      this.char_count = editorText.length;
    }
  }

  public clear_txt() {
    this.gotresponse = false;
    this.word_count = 0;
    this.char_count = 0;
    this.showParagraph = true;
    var testingnew = document.getElementById('editor');
    testingnew.textContent = '';
    this.showbuttons = false;
    this.loaderAlert = false;
    this.menuafterresponse = false;
  }

  public uploadFileSaveRedirect(event): void {
    $('#UpFileModal').modal({ backdrop: 'static', keyboard: false });

    const files: FileList = this.fileInput.nativeElement.files;
    var filetype = 'pdf';
    if (files[0].size > 5243000) {
      this.showAlert('File should be less than 5 MB.', '');
    } else {
      let input = event.target;
      this.menuafterresponse = false;
      this.gotresponse = false;
      this.loaderAlert = true;
      this.showParagraph = true;
      this.char_count = 0;
      this.showbuttons = false;
      this.showParagraph = false;
      var testingnew = document.getElementById('editor');
      if (testingnew.textContent != 'vv') {
        testingnew.textContent = '';
      }
      $('.hideUpload').hide('slow');
      this.webservices.uploadfilefrombrowser(files).subscribe(
        (data) => {
          this.loaderAlert = false;
          let receivedData = data;
          $('#editor').html(
            receivedData['RetCnt']
              .replace(/&quot;/g, '"')
              .replace(/&#x27;/g, "'")
              .replace(/&amp;/g, /&/g)
              .replace(/&gt;/g, '>')
              .replace(/&lt;/g, '<')
              .replace(/&quot;/g, /"/g)
          );
          this.getContent('', receivedData['RetCnt']);
          this.fileInput.nativeElement.value = '';
        },
        (error) => {
          this.loaderAlert = false;
          this.showAlert(
            'Unable to proceed with a password protected file.',
            ''
          );
        }
      );
    }
  }
  ////  gDriveUpload functionn

  public gDriveUpload() {
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
    setTimeout(() => {
      $('#editor').click();
    }, 500);

  }

  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult

    );

    setTimeout(() => {
      $('#editor').click();
    }, 500);
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }

  public handleAuthResult(authResult) {
    $('#UpFileModal').modal('hide');
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
        view.setMimeTypes(
          'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;

                swal({
                  background: '#FFFFFF',
                  title: 'Error',
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: '323px',
                  timer: 4000,
                });

                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close();
                    });
                  }
                }, 0);
              } else {
                if (e.docs[0].name.split('.')[1] === 'pdf') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'pdf',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('#editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                      );
                      this.homeText = return_data.RetCnt;


                      setTimeout(() => {
                        $('#editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name.split('.')[1] === 'txt') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';

                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'txt',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      this.hideothers = true;

                      $('#editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                      );
                      this.homeText = return_data.RetCnt;

                      setTimeout(() => {
                        $('#editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name) {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                    fileId +
                    '&exportFormat=docx';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'docx',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                      );
                      this.homeText = return_data.RetCnt;

                      setTimeout(() => {
                        $('#editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }


  count_Words_Character2() {


    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
  }

  ////  gDriveUpload functionn


  //// dropbox   functionn
  openDropboxChooser(): void {
    const options = {
      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
        }
      },
      cancel: () => { },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5,
    };
    Dropbox.choose(options);
  }
  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    this.word_count = 0;
    this.char_count = 0;
    this.spellingmistake = 0;
    this.garmmarmistake = 0;
    this.menuafterresponse = false;
    this.showonlydrive = false;
    this.showParagraph = false;
    this.loaderAlert = true;
    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });
    var data = { file_type: fileType, file_path: fileLink };
    this.showParagraph = false;
    this.webservices.dropboxfile(fileType, fileLink).subscribe((data) => {
      let receivedData = data;
      $('#editor').html(
        receivedData['RetCnt']
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/g, "'")
          .replace(/&amp;/g, /&/g)
          .replace(/&gt;/g, '>')
          .replace(/&lt;/g, '<')
          .replace(/&quot;/g, /"/g)
      );
      this.getContent('', receivedData['RetCnt']);
      this.loaderAlert = false;
    });
  }
  copyText() {
    const editorElement = $('#editor2').get(0);
    if (editorElement) {
      const range = document.createRange();
      range.selectNode(editorElement);
      window.getSelection()?.removeAllRanges();
      window.getSelection()?.addRange(range);
      try {
        document.execCommand('copy');
        this.copiedtext = true;
        this.copried_txt = 'copied';
        $('#copytextId').hide();
        $('#copried_txt').show();
        setTimeout(function () {
          $('#copried_txt').hide();
          $('#copytextId').show();
          this.copiedtext = false;
        }, 2000);
      } catch (err) {
        this.copiedtext = false;
      }
      window.getSelection()?.removeAllRanges();
    }
  }
  downloadText() {
   
    const editorElement = $('#editor2').get(0);
    if (editorElement) {
      this.loaderAlert = true;
      const textContent = editorElement.innerText;
      const blob = new Blob([textContent], { type: 'text/plain' });
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'text_file.txt';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
    this.loaderAlert = false;
  }
  @ViewChild('editor') textDivRef!: ElementRef;
  deleteText() {
    this.loaderAlert = true;
    if (this.textDivRef) {
      this.loaderAlert = true;
      this.textDivRef.nativeElement.innerHTML = '';
    }
    this.word_count = 0;
    this.char_count = 0;
    this.loaderAlert = false;
    this.showParagraph = true;


    const resultDiv = document.getElementById('editor2');
    if (this.gotresponse) {
      this.gotresponse = false;
    }

    if (resultDiv) {
      resultDiv.innerHTML = "";
      const imgElement = document.createElement("img");
      imgElement.src = "../../assets/images/article-rewriter/result-section.png";
      imgElement.className = "result-section-img";
      imgElement.style.position = "relative";
      imgElement.style.top = "40%";
      imgElement.style.left = "49%";
      imgElement.style.textAlign = "center";
      imgElement.style.transform = "translate(-50%, -50%)";
      imgElement.style.display = "block";
      resultDiv.appendChild(imgElement);
    }
  }
  //  objects objects objects

  executeAction(action: string) {
    if (this[action] && typeof this[action] === 'function') {
      this[action]();
    } else {

    }
  }

  contentArray = [
    {
      showParagraph: true,
      header: 'Upload Your Content',
      paragraph: 'Type or Paste AI Text here',
      buttons: [
        {
          text: 'Sample Text',
          icon: 'copyIcon',
          action: 'sampletext'
        },
        {
          text: 'Paste Text',
          icon: 'copyIcon',
          action: 'pasteText'
        }

      ]
    }
  ];
}
